/* Product photos in a full screen view (request 124). Opens from the main photo or its enlarge button; shows every
   photo of the version on show with all thumbnails visible, a counter, arrows, the arrow keys and a swipe; a click or
   tap zooms in where it lands and the photo then follows the pointer; Escape, the close button or a tap outside the
   photo closes it and focus returns to the photo. On opening the dialog itself takes focus, so no button shows selected. A native <dialog>, so focus stays inside and the page behind is
   inert. Research: Baymard (image gallery overlay: all thumbnails visible, enough resolution and zoom), WAI-ARIA
   modal dialog practice. */
(() => {
  const stage = document.querySelector("[data-lp-stage]");
  if (!stage) return;
  const name = document.querySelector(".lp-info h1")?.textContent.trim() || "Product";
  const big = (src) => src.replace(/([?&])width=\d+/, "$1width=2400");
  const icon = (d) => `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="${d}"/></svg>`;
  const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* The enlarge button on the main photo; put back if the photo is swapped for another version. */
  const ensureButton = () => {
    if (!stage.querySelector("img") || stage.querySelector("[data-lp-zoom]")) return;
    stage.insertAdjacentHTML("beforeend", `<button type="button" class="lp-zoom" data-lp-zoom aria-label="Enlarge photo">${icon("M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7")}</button>`);
  };
  ensureButton();
  new MutationObserver(ensureButton).observe(stage, { childList: true });

  const dlg = document.createElement("dialog");
  dlg.className = "lbx";
  dlg.tabIndex = -1;
  dlg.setAttribute("aria-label", `Photos of ${name}`);
  dlg.innerHTML = `<div class="lbx-top"><span class="lbx-count" aria-live="polite"></span><span class="lbx-name"></span>
      <button type="button" class="lbx-x" aria-label="Close">${icon("M6 6l12 12M18 6 6 18")}</button></div>
    <div class="lbx-stage"><img class="lbx-img" alt="" draggable="false"></div>
    <button type="button" class="lbx-nav lbx-prev" aria-label="Previous photo">${icon("M15 5l-7 7 7 7")}</button>
    <button type="button" class="lbx-nav lbx-next" aria-label="Next photo">${icon("M9 5l7 7-7 7")}</button>
    <div class="lbx-thumbs"></div>`;
  document.body.appendChild(dlg);
  const $ = (s) => dlg.querySelector(s);
  const img = $(".lbx-img"), view = $(".lbx-stage"), count = $(".lbx-count"), strip = $(".lbx-thumbs");
  $(".lbx-name").textContent = name;

  let list = [], lowAt = [], at = 0, zoomed = false;
  const photos = () => {
    const th = [...document.querySelectorAll("[data-lp-thumbs]:not([hidden]) .lp-thumb")];
    if (th.length) return { srcs: th.map((b) => b.dataset.src), thumbs: th.map((b) => b.querySelector("img")?.src || b.dataset.src),
      low: th.map((b) => b.hasAttribute("data-low")), at: Math.max(0, th.findIndex((b) => b.classList.contains("on"))) };
    const si = stage.querySelector("img");
    const s = si?.currentSrc || si?.src;
    return s ? { srcs: [s], thumbs: [s], low: [si.dataset.low === "true"], at: 0 } : null;
  };
  /* Zoom up to the photo's own pixels (at most 2.5 times) and only when that adds real detail (1.5 times or more);
     never for a photo the review graded low (under 800 px, upscaled or a phone photo: tools/luz_photo_quality.py). */
  const room = () => (img.naturalWidth && img.clientWidth ? Math.min(2.5, img.naturalWidth / img.clientWidth) : 1);
  const zoomable = () => !lowAt[at] && room() >= 1.5;
  const zoom = (on, e) => {
    if (on && !zoomable()) on = false;
    zoomed = on;
    img.style.setProperty("--z", room().toFixed(2));
    dlg.classList.toggle("is-zoomed", on);
    if (on && e) follow(e);
    if (!on) img.style.transformOrigin = "";
  };
  const follow = (e) => {
    const r = view.getBoundingClientRect();
    const x = Math.min(100, Math.max(0, ((e.clientX - r.left) / r.width) * 100));
    const y = Math.min(100, Math.max(0, ((e.clientY - r.top) / r.height) * 100));
    img.style.transformOrigin = `${x}% ${y}%`;
  };
  const show = (n) => {
    at = (n + list.length) % list.length;
    zoom(false);
    img.src = big(list[at]);
    img.alt = `${name}, photo ${at + 1} of ${list.length}`;
    dlg.classList.remove("can-zoom");
    count.textContent = list.length > 1 ? `${at + 1} / ${list.length}` : "";
    strip.querySelectorAll("button").forEach((b, i) => { b.classList.toggle("on", i === at); b.setAttribute("aria-current", i === at); });
    strip.querySelector(".on")?.scrollIntoView({ block: "nearest", inline: "center", behavior: reduce ? "auto" : "smooth" });
    [list[at + 1], list[at - 1]].forEach((s) => { if (s) new Image().src = big(s); });
  };
  const open = () => {
    const p = photos();
    if (!p) return;
    list = p.srcs;
    lowAt = p.low;
    dlg.classList.toggle("is-single", list.length < 2);
    strip.innerHTML = list.length > 1 ? p.thumbs.map((t, i) => `<button type="button" aria-label="Photo ${i + 1}"><img src="${t}" alt=""></button>`).join("") : "";
    document.documentElement.classList.add("lbx-lock");
    dlg.showModal();
    dlg.focus();
    show(p.at);
  };
  img.addEventListener("load", () => dlg.classList.toggle("can-zoom", zoomable()));
  dlg.addEventListener("close", () => { document.documentElement.classList.remove("lbx-lock"); zoom(false); });

  stage.addEventListener("click", (e) => { if (e.target.closest("[data-lp-zoom]") || e.target.closest("img")) open(); });
  $(".lbx-x").addEventListener("click", () => dlg.close());
  $(".lbx-prev").addEventListener("click", () => show(at - 1));
  $(".lbx-next").addEventListener("click", () => show(at + 1));
  strip.addEventListener("click", (e) => { const b = e.target.closest("button"); if (b) show([...strip.children].indexOf(b)); });
  dlg.addEventListener("keydown", (e) => {
    if (e.key === "ArrowRight" && list.length > 1) { e.preventDefault(); show(at + 1); }
    if (e.key === "ArrowLeft" && list.length > 1) { e.preventDefault(); show(at - 1); }
  });

  /* A click or tap zooms in where it lands (or out); a horizontal swipe changes photo; a tap beside the photo closes. */
  let x0 = null, y0 = 0, moved = false;
  view.addEventListener("pointerdown", (e) => { x0 = e.clientX; y0 = e.clientY; moved = false; });
  view.addEventListener("pointermove", (e) => {
    if (x0 !== null && Math.hypot(e.clientX - x0, e.clientY - y0) > 8) moved = true;
    if (zoomed && (e.pointerType === "mouse" || x0 !== null)) follow(e);
  });
  view.addEventListener("pointerup", (e) => {
    if (x0 === null) return;
    const dx = e.clientX - x0, dy = e.clientY - y0;
    x0 = null;
    if (!zoomed && list.length > 1 && Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) { show(at + (dx < 0 ? 1 : -1)); return; }
    if (moved) return;
    if (e.target === img) zoom(!zoomed, e);
    else if (!zoomed) dlg.close();
    else zoom(false);
  });
  view.addEventListener("pointercancel", () => { x0 = null; });
})();
